/* Rekover : effet « liquid metal » sur quelques textes (le grand REKOVER et des titres clés).
   Le texte reste dans la page (lisible par Google et les lecteurs d'écran) ; on le redessine dans un petit canvas WebGL :
   chrome qui coule, reliefs arrondis, reflets irisés sur les bords. Sans WebGL, le style argent en CSS reste affiché. */
(function () {
  'use strict';
  var SEL = '[data-liquid], .rkb .rkr__base, .rk-arc__title, .spotlight__title, .rkb__end .rkb__title';
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = matchMedia('(hover: hover) and (pointer: fine)').matches;
  var DPR = Math.min(window.devicePixelRatio || 1, 2);

  var VS = 'attribute vec2 p;varying vec2 v;void main(){v=p*.5+.5;gl_Position=vec4(p,0.,1.);}';
  var FS = [
    'precision highp float;',
    'uniform sampler2D uM,uB;uniform vec2 uA,uPx,uMs;uniform float uT,uMi;varying vec2 v;',
    'float env(float t){',
    '  float f=fract(t);',
    '  float dark=smoothstep(.26,.4,f)*(1.-smoothstep(.48,.64,f));',
    '  float g=.84+.13*sin(t*12.566+.7);',
    '  return mix(g,.09,dark);',
    '}',
    'void main(){',
    '  vec2 uv=vec2(v.x,1.-v.y);',
    '  float m=texture2D(uM,uv).r;',
    '  if(m<.004){gl_FragColor=vec4(0.);return;}',
    '  float b=texture2D(uB,uv).r;',
    '  float bx=texture2D(uB,uv+vec2(uPx.x,0.)).r-texture2D(uB,uv-vec2(uPx.x,0.)).r;',
    '  float by=texture2D(uB,uv+vec2(0.,uPx.y)).r-texture2D(uB,uv-vec2(0.,uPx.y)).r;',
    '  vec2 n=vec2(bx,by)*3.2;',
    '  float edge=1.-smoothstep(.12,.8,b);',
    '  vec2 q=uv*uA;',
    '  float flow=sin(q.x*2.1+uT*.55+sin(q.y*3.+uT*.3))*.09+sin(q.y*3.4-uT*.42+q.x*1.3)*.06;',
    '  float md=length((uv-uMs)*uA);',
    '  float t=uv.y*.62+n.y*.5-n.x*.22+flow*.8+uT*.04+edge*.3+uMi*.22*exp(-md*md*6.);',
    '  float d=.012+edge*.06;',
    '  vec3 col=vec3(env(t+d),env(t),env(t-d));',
    '  col=mix(col,col*vec3(.92,.96,1.06),.5);',
    '  col*=1.-.38*edge;',
    '  col+=edge*vec3(.0,.02,.06);',
    '  gl_FragColor=vec4(col*m,m);',
    '}'
  ].join('\n');

  function boxBlur(src, w, h, r) {
    // trois flous boîte horizontaux + verticaux ≈ flou gaussien
    var a = src, b = new Float32Array(w * h);
    for (var pass = 0; pass < 3; pass++) {
      for (var y = 0; y < h; y++) {
        var row = y * w, acc = 0, k;
        for (k = -r; k <= r; k++) acc += a[row + Math.min(w - 1, Math.max(0, k))];
        for (var x = 0; x < w; x++) {
          b[row + x] = acc / (2 * r + 1);
          acc += a[row + Math.min(w - 1, x + r + 1)] - a[row + Math.max(0, x - r)];
        }
      }
      for (var x2 = 0; x2 < w; x2++) {
        var acc2 = 0, k2;
        for (k2 = -r; k2 <= r; k2++) acc2 += b[Math.min(h - 1, Math.max(0, k2)) * w + x2];
        for (var y2 = 0; y2 < h; y2++) {
          a[y2 * w + x2] = acc2 / (2 * r + 1);
          acc2 += b[Math.min(h - 1, y2 + r + 1) * w + x2] - b[Math.max(0, y2 - r) * w + x2];
        }
      }
    }
    return a;
  }

  function Liquid(el) {
    this.el = el;
    var cv = this.cv = document.createElement('canvas');
    cv.className = 'rk-liq__canvas'; cv.setAttribute('aria-hidden', 'true');
    var gl = this.gl = cv.getContext('webgl', { premultipliedAlpha: true, alpha: true, antialias: false });
    if (!gl) throw new Error('webgl');
    var sh = function (type, src) { var s = gl.createShader(type); gl.shaderSource(s, src); gl.compileShader(s); if (!gl.getShaderParameter(s, gl.COMPILE_STATUS)) throw new Error(gl.getShaderInfoLog(s)); return s; };
    var pr = gl.createProgram(); gl.attachShader(pr, sh(gl.VERTEX_SHADER, VS)); gl.attachShader(pr, sh(gl.FRAGMENT_SHADER, FS)); gl.linkProgram(pr);
    if (!gl.getProgramParameter(pr, gl.LINK_STATUS)) throw new Error('link');
    gl.useProgram(pr);
    var buf = gl.createBuffer(); gl.bindBuffer(gl.ARRAY_BUFFER, buf);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 1, -1, -1, 1, 1, 1]), gl.STATIC_DRAW);
    var loc = gl.getAttribLocation(pr, 'p'); gl.enableVertexAttribArray(loc); gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);
    this.u = {}; var self = this;
    ['uM', 'uB', 'uA', 'uPx', 'uT', 'uMs', 'uMi'].forEach(function (n) { self.u[n] = gl.getUniformLocation(pr, n); });
    this.tM = gl.createTexture(); this.tB = gl.createTexture();
    gl.uniform1i(this.u.uM, 0); gl.uniform1i(this.u.uB, 1);
    gl.enable(gl.BLEND); gl.blendFunc(gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
    this.mx = 0.5; this.my = 0.5; this.mi = 0; this.mit = 0;
    if (getComputedStyle(el).position === 'static') el.style.position = 'relative';
    el.appendChild(cv);
    el.classList.add('rk-liq');
    this.build();
  }

  Liquid.prototype.build = function () {
    var el = this.el, gl = this.gl, cs = getComputedStyle(el);
    var r = el.getBoundingClientRect();
    if (!r.width || !r.height) return;
    var fs = parseFloat(cs.fontSize) || 40, pad = Math.round(fs * 0.18);
    var W = Math.round(r.width + pad * 2), H = Math.round(r.height + pad * 2);
    this.pad = pad; this.W = W; this.H = H;
    var cv = this.cv;
    cv.style.left = -pad + 'px'; cv.style.top = -pad + 'px'; cv.style.width = W + 'px'; cv.style.height = H + 'px';
    var pw = Math.round(W * DPR), ph = Math.round(H * DPR);
    cv.width = pw; cv.height = ph;

    // 1. le texte en blanc sur noir, exactement là où le navigateur l'a placé
    var m = document.createElement('canvas'); m.width = pw; m.height = ph;
    var c = m.getContext('2d');
    c.fillStyle = '#000'; c.fillRect(0, 0, pw, ph);
    c.fillStyle = '#fff'; c.textBaseline = 'alphabetic';
    c.font = cs.fontStyle + ' ' + cs.fontWeight + ' ' + (fs * DPR) + 'px ' + cs.fontFamily;
    var ls = parseFloat(cs.letterSpacing) || 0;
    if ('letterSpacing' in c) c.letterSpacing = (ls * DPR) + 'px';
    var upper = cs.textTransform === 'uppercase';
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var node, range = document.createRange(), probe = c.measureText('ÉHg');
    var asc = probe.fontBoundingBoxAscent || fs * DPR * 0.92, desc = probe.fontBoundingBoxDescent || fs * DPR * 0.24;
    while ((node = walker.nextNode())) {
      if (node.parentNode === this.cv) continue;
      var txt = node.nodeValue, re = /\S+/g, mm;
      while ((mm = re.exec(txt))) {
        range.setStart(node, mm.index); range.setEnd(node, mm.index + mm[0].length);
        var rects = range.getClientRects(); if (!rects.length) continue;
        var wr = rects[0], word = upper ? mm[0].toUpperCase() : mm[0];
        var x = (wr.left - r.left + pad) * DPR;
        var y = (wr.top - r.top + pad) * DPR + (wr.height * DPR - (asc + desc)) / 2 + asc;
        c.fillText(word, x, y);
      }
    }
    var img = c.getImageData(0, 0, pw, ph).data;

    // 2. version floue (plus petite) : donne le relief arrondi des lettres
    var s = 0.5, bw = Math.max(2, Math.round(pw * s)), bh = Math.max(2, Math.round(ph * s));
    var small = new Float32Array(bw * bh);
    for (var yy = 0; yy < bh; yy++) for (var xx = 0; xx < bw; xx++) small[yy * bw + xx] = img[((Math.min(ph - 1, Math.round(yy / s)) * pw) + Math.min(pw - 1, Math.round(xx / s))) * 4] / 255;
    var rad = Math.max(1, Math.round(fs * DPR * s * 0.03));
    var bl = boxBlur(small, bw, bh, rad);
    var b8 = new Uint8Array(bw * bh); for (var i = 0; i < b8.length; i++) b8[i] = Math.min(255, bl[i] * 255 * 1.35);
    var m8 = new Uint8Array(pw * ph); for (var j = 0; j < m8.length; j++) m8[j] = img[j * 4];

    gl.pixelStorei(gl.UNPACK_ALIGNMENT, 1);
    var up = function (tex, unit, w, h, data) {
      gl.activeTexture(gl.TEXTURE0 + unit); gl.bindTexture(gl.TEXTURE_2D, tex);
      gl.texImage2D(gl.TEXTURE_2D, 0, gl.LUMINANCE, w, h, 0, gl.LUMINANCE, gl.UNSIGNED_BYTE, data);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR); gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE); gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
    };
    up(this.tM, 0, pw, ph, m8); up(this.tB, 1, bw, bh, b8);
    gl.viewport(0, 0, pw, ph);
    gl.uniform2f(this.u.uA, W / Math.max(1, Math.min(W, H) * 2.2), H / Math.max(1, Math.min(W, H) * 2.2));
    gl.uniform2f(this.u.uPx, 1.5 / bw, 1.5 / bh);
    this.ready = true;
    this.draw(performance.now());
  };

  Liquid.prototype.draw = function (now) {
    if (!this.ready) return;
    var gl = this.gl;
    this.mi += (this.mit - this.mi) * 0.06;
    gl.uniform1f(this.u.uT, reduce ? 3.0 : now / 1000);
    gl.uniform2f(this.u.uMs, this.mx, this.my);
    gl.uniform1f(this.u.uMi, this.mi);
    gl.clearColor(0, 0, 0, 0); gl.clear(gl.COLOR_BUFFER_BIT);
    gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
  };

  function start() {
    var els = Array.prototype.slice.call(document.querySelectorAll(SEL)).slice(0, 6);
    if (!els.length) return;
    var items = [];
    els.forEach(function (el) {
      if (el.dataset.liqReady) return; el.dataset.liqReady = '1';
      try { items.push(new Liquid(el)); } catch (e) { el.classList.remove('rk-liq'); }
    });
    if (!items.length) return;
    var vis = new Map();
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { vis.set(e.target, e.isIntersecting); }); }, { rootMargin: '100px' });
    items.forEach(function (it) { io.observe(it.el); vis.set(it.el, true); });
    if (fine) addEventListener('pointermove', function (e) {
      items.forEach(function (it) {
        var r = it.cv.getBoundingClientRect(); if (!r.width) return;
        it.mx = (e.clientX - r.left) / r.width; it.my = (e.clientY - r.top) / r.height;
        it.mit = (it.mx > -0.1 && it.mx < 1.1 && it.my > -0.3 && it.my < 1.3) ? 1 : 0;
      });
    }, { passive: true });
    var t = 0;
    var rebuild = function () { clearTimeout(t); t = setTimeout(function () { items.forEach(function (it) { it.build(); }); }, 160); };
    if ('ResizeObserver' in window) { var ro = new ResizeObserver(rebuild); items.forEach(function (it) { ro.observe(it.el); }); }
    else addEventListener('resize', rebuild);
    if (reduce) return;
    (function loop(now) {
      requestAnimationFrame(loop);
      items.forEach(function (it) { if (vis.get(it.el)) it.draw(now); });
    })(performance.now());
  }

  var go = function () { (document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve()).then(function () { setTimeout(start, 60); }); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go); else go();
})();
